export enum Levels {
  ALL = 'All',
  CLIENT = 'Client',
  PROGRAM = 'Program',
  SITE = 'Site',
  PROJECT = 'Project',
  USER = 'User',
  DOCUMENT = 'File'
}
